import React from 'react';

import { bool, func } from 'prop-types';

import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';

import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import Tooltip from 'components/Common/Tooltip';

const PasswordInputAdornment = ({ showPassword, setShowPassword }) => (
  <InputAdornment position="end">
    <Tooltip
      placement="top"
      title={showPassword ? 'Hide Password' : 'Show Password'}
    >
      <IconButton
        disableRipple
        disableFocusRipple
        aria-label="Toggle password visibility"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? (
          <FontAwesomeIcon icon={faEye} size="2xs" />
        ) : (
          <FontAwesomeIcon icon={faEyeSlash} size="2xs" />
        )}
      </IconButton>
    </Tooltip>
  </InputAdornment>
);

PasswordInputAdornment.propTypes = {
  showPassword: bool.isRequired,
  setShowPassword: func.isRequired,
};

export default PasswordInputAdornment;
